module.exports = __webpack_public_path__ + "static/media/gc-restaurant.8f6beaf9.png";